import { render, staticRenderFns } from "./SalesAmount.vue?vue&type=template&id=7cdc0f04"
import script from "./SalesAmount.vue?vue&type=script&lang=js"
export * from "./SalesAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports